import { render } from "./MatrixControl.vue?vue&type=template&id=76645a3a&ts=true"
import script from "./MatrixControl.vue?vue&type=script&lang=ts"
export * from "./MatrixControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__